import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {PathService} from '../../login/services/path.service';
import {Observable} from 'rxjs';
import {PreferenceDtoModel} from '../models/preference.dto.model';

@Injectable({
    providedIn: 'root'
})
export class PreferencesServices {
    private baseUrl = '';

    constructor(protected http: HttpClient, private pathService: PathService) {
        this.baseUrl = `${pathService.hostServerBackOffice}/preferences`;
    }

    public findAllPreferences(): Observable<PreferenceDtoModel[]> {
        return this.http.get<PreferenceDtoModel[]>(`${this.baseUrl}/all`);
    }
}
